import { Col, ColType, Crud, CrudApi, CrudAction } from "../../comp/crud";
import {
  ApiClient,
  displayLeadStatus,
  displayLeadType,
  getLeadTypeOpt,
  getLeadStatusOpt,
} from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { displayStar } from "../../utils";
import { Tag, Button, Form, Modal, Toast } from "@douyinfe/semi-ui";
import { TextCell, TextCellRemark } from "../../comp/cell";
import React, { useEffect, useMemo, useState } from "react";
import { IconModalStroked } from "@douyinfe/semi-icons";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
export interface LeadCheckEmptyMobileProps {
  statDate?: string;
  checkResult?: number;
  leadStar?: number;
  leadName?: string;
  leadMobile?: string;
  updatedAt?: string;
  source?: string;
  applyCity?: string;
}

export default function LeadCheckEmptyMobileDetail(
  props: LeadCheckEmptyMobileProps
) {
  const [filterSource, setFilterSource] = useState(true);
  const [filterLeadName, setFilterLeadName] = useState(true);
  const [filterUpdatedAt, setFilterUpdatedAt] = useState(true);
  const [filterLeadStar, setFilterLeadStar] = useState(true);
  const [filterLeadMobile, setFilterLeadMobile] = useState(true);
  const [filterApplyCity, setFilterApplyCity] = useState(true);

  const apiClient = ApiClient.getDefault();
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [poolSaving, setPoolSaving] = useState(false);
  const [showPoolModal, setShowPoolModal] = useState(false);
  const [poolFormApi, setPoolFormApi] = useState(
      undefined as undefined | FormApi
    );
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");

  let cols: Col[] = [
    {
      name: "客户姓名",
      key: "leadName",
      showInFilter: filterLeadName,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="primary"
            onClick={() => detailAction(record)}
          >
            {value}
          </Button>
        );
      },
    },
    {
          name: "城市",
          key: "applyCity",
          showInFilter: true,
          type: ColType.SELECT,
          getOptions: () => apiClient.getDictAsOpts("city"),
        },
    {
      name: "客户类型",
      key: "leadType",
      colSort: 1,
      colFilterSort: 6,
      showInFilter: true,
      hideInCreate: true,
      render: (value, index) => displayLeadType(value),
      getOptions: () => Promise.resolve(getLeadTypeOpt()),
      type: ColType.SELECT,
      width: 100,
    },
{
      name: "销售",
      key: "saleName",
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "手机号",
      key: "leadMobile",
      showInFilter: filterLeadMobile,
      type: ColType.STRING,
    },

    {
      name: "检测结果",
      key: "checkResultDesc",
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "渠道",
      key: "source",
      showInFilter: filterSource,
      type: ColType.STRING,
    },
    {
      name: "星级",
      key: "leadStar",
      showInFilter: filterLeadStar,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    
    {
      name: "状态",
      key: "status",
      width: 70,
      colSort: 3,
      showInFilter: false,
      colFilterSort: 3,
      hideInCreate: true,
      render: (value, index) => {
        if (value == "PENDING_CONTACT") {
          return (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "UNREACHABLE") {
          return (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "OUT_LEAD") {
          return (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "INVITATION_IN_PROGRESS") {
          return (
            <Tag
              color="orange"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "NON_COMPLIANCE") {
          return (
            <Tag
              color="teal"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PENDING_VISIT") {
          return (
            <Tag
              color="purple"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "VISITED") {
          return (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "SIGNED_CONTRACT") {
          return (
            <Tag
              color="violet"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PAID") {
          return (
            <Tag
              color="yellow"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else {
          return (
            <Tag key={value} size="large" shape="circle" type="solid">
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        }
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "跟进记录",
      key: "contactLogs",
      colSort: 8,
      hideInEdit: true,
      width: 210,
      hideInCreate: true,
      showInFilter: false,
      render: (value, index) => (
        <TextCellRemark moreText={value ? value : []} width={200} />
      ),
      type: ColType.STRING,
    },
    {
      name: "客户入库时间",
      key: "leadCreatedAt",
      showInFilter: false,
      type: ColType.DATE_RANGE,
    },
    {
      name: "检测时间",
      key: "updatedAt",
      showInFilter: false,
      hideInList: false,
      type: ColType.DATE_RANGE,
    },
  ];

  const initFilterValues = {
    statDate: props.statDate,
    checkResult: props.checkResult,
    source: props.source,
    leadStar: props.leadStar,
    applyCity: props.applyCity,
    leadName: props.leadName,
    leadMobile: props.leadMobile,
    updatedAt: props.updatedAt,
  };
  const initParams = {
    statDate: props.statDate,
    checkResult: props.checkResult,
    source: props.source,
    leadStar: props.leadStar,
    applyCity: props.applyCity,
    leadName: props.leadName,
    leadMobile: props.leadMobile,
    updatedAt: props.updatedAt,
  };

  useEffect(() => {
    if (props.source) {
      setFilterSource(false);
    }
    if (props.leadName && props.leadName != "") {
      setFilterLeadName(false);
    }
    if (props.updatedAt && props.updatedAt != "") {
      setFilterUpdatedAt(false);
    }
    if (props.leadMobile && props.leadMobile != "") {
      setFilterLeadMobile(false);
    }
    if (props.leadStar) {
      setFilterLeadStar(false);
    }
    if (props.applyCity && props.applyCity != "") {
      setFilterApplyCity(false);
    }

    let currUsername;
    if (role == "op_manager" || role == "monitor" || role == "foreground") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));
  }, []);

  //打开详情
  const detailAction = (a: any) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type: "all",
    };
    if (w != null) {
      //获取表格data的id列表
      const ids = crudApi?.getData()?.map((i) => i.leadId);
      const data = {
        id: a.leadId,
        ids: ids,
        viewMode: true,
        visitMode: false,
        leadFrom: "report",
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      setSelectedLeads([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowAssignModal(false);
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handlePoolClick = async () => {
    setPoolSaving(true);
    try {
      await poolFormApi!.validate();
      await apiClient.request(
        "/leads/pool",
        "POST",
        undefined,
        poolFormApi!.getValues()
      );

      crudApi?.refresh();
     
      setPoolSaving(false);
      setShowPoolModal(false);
      setSelectedLeads([]);
    
    } catch (e) {
      console.log(e);
      setPoolSaving(false);
    }
  };

  const handleAssignButtonClick = (row: any, rows: any) => {
    if (rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    let leads = [];
    for (let i = 0; i < rows.length; i++) {
      leads.push({ id: rows[i].leadId, name: rows[i].leadName });
    }
    setSelectedLeads(leads);
    setShowAssignModal(true);
  };

  const handlePoolButtonClick = (a: any, rows: any) => {
      if (!rows || rows.length == 0) {
        Toast.info("请选择客户");
        return;
      }
      let leads = [];
    for (let i = 0; i < rows.length; i++) {
      leads.push({ id: rows[i].leadId, name: rows[i].leadName });
    }
      setSelectedLeads(leads);
      setShowPoolModal(true);
    };

  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };
  const sendToPoolAction: CrudAction = {
      name: "送回公共池",
      action: handlePoolButtonClick,
    };

  const actions: CrudAction[] = [];
  actions.push(assignAction);
  actions.push(sendToPoolAction);

  const renderLabel = (label: any, item: any) => (
    <div
      style={{
        padding: "6px 8px",
        lineHeight: 1.0,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "var(--semi-color-text-0)",
          fontSize: 14,
        }}
      >
        {label}
        <span
          style={{
            fontSize: 12,
            color: "var(--semi-color-text-2)",
            marginLeft: 10,
          }}
        >
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  

  return (
    <div>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400,
            }}
          ></Form.TreeSelect>

          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
              icon={
                <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
              }
              title="送回公共池"
              visible={showPoolModal}
              okText="送回公共池"
              confirmLoading={poolSaving}
              onOk={handlePoolClick}
              onCancel={() => setShowPoolModal(false)}
            >
              <Form getFormApi={(formApi) => setPoolFormApi(formApi)}>
                <Form.Select
                  rules={[{ required: true, message: "请填写" }]}
                  disabled
                  initValue={selectedLeads.map((l) => l.id)}
                  style={{ width: "100%" }}
                  multiple
                  field="leadIds"
                  label="客户"
                >
                  {selectedLeads.map((l) => (
                    <Form.Select.Option key={l.id + ""} value={l.id}>
                      {l.name}
                    </Form.Select.Option>
                  ))}
                </Form.Select>
              </Form>
            </Modal>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        canExport={true}
        name="空号检测明细"
        entityKey="leadCheckEmptyMobileLog/queryLeadCheckEmptyMobilePage"
        initFilterValues={initFilterValues}
        params={initParams}
        actions={actions}
        select={true}
        pageSize={50}
        cols={cols}
      />
    </div>
  );
}
